import Isotope from 'isotope-layout';

const { Intercom, makeSameHeight } = window;

const themesNav = () => {
  const nav = document.getElementById('themes-nav');

  // V2 won't have a nav, so skip it
  if (!nav) return;

  const iso = new Isotope('.expertsGrid', {
    itemSelector: '.cardParent',
    layoutMode: 'fitRows'
  });

  nav.addEventListener('click', (e) => {
    e.preventDefault();

    const type = e.target.dataset.type.toLowerCase();
    const filter = type !== 'all' ? `.${type}` : '*';

    iso.arrange({ filter });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  makeSameHeight('.card-collection > .col', true);

  const btn = document.getElementsByClassName('expert-btn')[0];

  btn.addEventListener('click', () => {
    Intercom('showNewMessage');
    return false;
  });

  themesNav();
});
